import { render } from "./copyright-patent.vue?vue&type=template&id=c01302da&scoped=true"
import script from "./copyright-patent.vue?vue&type=script&lang=js"
export * from "./copyright-patent.vue?vue&type=script&lang=js"

import "./copyright.less?vue&type=style&index=0&id=c01302da&lang=less&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/NM12r8skh/0/website/official-website-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c01302da"]])

export default __exports__